import { agentTenantMapping } from "../../../../services/tenantAgentMapping";
import React, { useEffect, useState } from "react";
import { Button } from '../../../../components/ui/Button';
import { Checkbox } from '../../../../components/ui/Field';
import { Overlay } from '../../../../components/ui/Overlay';
import { Surface } from '../../../../components/ui/Surface';

interface Tenant {
  id: string;
  name: string;
}

interface TenantModalProps {
  isOpen: boolean;
  tenants: Tenant[];
  onClose: () => void;
  onSave: (selected: string[], agentTypeId: string) => void;
  agentTypeId: string;
}

const TenantModal: React.FC<TenantModalProps> = ({ isOpen, tenants, onClose, onSave, agentTypeId}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [tenantIds, setTenantIds] = useState<string[]>([]);

  const toggleTenant = (id: string) => {
    setTenantIds((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
    );
  };

  const getMapping = async () => {
    const data = await agentTenantMapping.listTenantMappingFromAgent({
      agentTypeId: agentTypeId
    })

    setTenantIds(data.map((item: any) => item.tenantId));
  }

  useEffect(() => {
    if(agentTypeId)
    getMapping()
  }, [agentTypeId])

  const handleSave = () => {
    const selected : string[] = tenantIds.map((t) => t);
    onSave(selected, agentTypeId);
    onClose()
  };

  if (!isOpen) return null;

  return (
    <Overlay className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-black/30" onClick={onClose}></div>

      {/* Modal Card */}
      <Surface tone="popover" className="relative w-full max-w-2xl mx-4 rounded-2xl border p-6 max-h-[85vh] overflow-y-auto">

        <h2 className="text-xl font-semibold text-agentic-text-primary">Tenant List</h2>
        <p className="text-sm text-agentic-text-secondary mt-1">Select tenants using the dropdown.</p>

        {/* Custom Multi-Select Dropdown */}
        <div className="mt-5">
          <label className="block text-sm font-medium text-agentic-text-primary mb-1">
            Select Tenants
          </label>

          {/* Dropdown Button */}
          <div
            className="border border-gray-300 rounded-lg p-2 cursor-pointer select-none flex justify-between items-center"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <span className="text-sm text-gray-700">
              {tenantIds.length > 0
                ? `${tenantIds.length} selected`
                : "Choose tenants"}
            </span>
            <span className="text-gray-500">▼</span>
          </div>

          {/* Dropdown List */}
          {dropdownOpen && (
            <div className="mt-1 border border-gray-300 rounded-lg bg-white shadow p-2 max-h-56 overflow-y-auto">
              {tenants.map((tenant) => (
                <label key={tenant.id} className="flex items-center gap-2 py-1 cursor-pointer">
                  <Checkbox
                   
                    checked={tenantIds.includes(tenant.id)}
                    onChange={() => toggleTenant(tenant.id)}
                  />
                  <span className="text-sm">{tenant.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        {/* Selected Tenants Column List */}
        {/* <div className="mt-6">
          <label className="block text-sm font-medium text-agentic-text-primary mb-2">
            Selected Tenants
          </label>

          {selectedTenantIds.length === 0 ? (
            <p className="text-sm text-agentic-text-secondary">No tenants selected.</p>
          ) : (
            <div className="flex flex-col gap-2 border border-gray-200 rounded-lg p-3 max-h-48 overflow-y-auto">
              {tenants
                .filter((t) => selectedTenantIds.includes(t.id))
                .map((tenant) => (
                  <div key={tenant.id} className="flex justify-between items-center py-1">
                    <span className="text-sm text-agentic-text-primary">{tenant.name}</span>
                    <Button tone="danger-text"
                      className="text-xs"
                      onClick={() => toggleTenant(tenant.id)}
                    >
                      Remove
                    </Button>
                  </div>
                ))}
            </div>
          )}
        </div> */}

        {/* Buttons */}
        <div className="flex items-center justify-end space-x-3 pt-4 mt-4">
          <Button tone="outline-muted"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border"
          >
            Cancel
          </Button>

          <Button tone="primary-gradient"
            onClick={handleSave}
            className="px-4 py-2 rounded-lg"
          >
            Save
          </Button>
        </div>
      </Surface>
    </Overlay>
  );
};

export default TenantModal;
